import type { ApiEmbedSearchWidgetId, ApiS3FileId } from 'api/types/ApiTypedId';
import type { BackgroundTask } from 'utils/asyncBackendTask/asyncBackendTaskTypes';
import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';

type ApiResponse = {
  task: BackgroundTask<void>;
};

function mapResponse(response: ApiResponse) {
  return response.task;
}

const endpoint = new FetchEndpoint({
  urlFactory: (
    embedSearchWidgetId: ApiEmbedSearchWidgetId,
    fileId: ApiS3FileId,
  ) => `/data/embed-search-widgets/${embedSearchWidgetId}/files/${fileId}/done`,
  mapResponse,
  optionsFactory: () => ({ method: 'post', body: {} }),
});

export const embedSearchWidgetApiClientFetchS3FileUploadTask =
  endpoint.createClientFetchFn();
